import { EWebinarSetGroup, HomePageSetFragment } from '$/GraphQL/schema/schema';

export const getPublishedSets = (sets: HomePageSetFragment[]): HomePageSetFragment[] => {
  let publishedSets: HomePageSetFragment[] = sets?.filter(
    (set) => set.group === EWebinarSetGroup.Published
  );

  // sort
  publishedSets = publishedSets.sort((a, b) => {
    return a.title.localeCompare(b.title);
  });
  return publishedSets;
};
